/** Better Auth endpoints under /api/auth (email + password, email codes). Cookies carry the session. */
import { request } from "./http";

type OtpType = "email-verification" | "sign-in" | "forget-password";

export const authApi = {
  signIn: (email: string, password: string) => request<unknown>("POST", "/api/auth/sign-in/email", { email, password }),
  /** The API refuses a sign-up without `acceptTerms: true` (the form's required Terms box). */
  signUp: (name: string, email: string, password: string, consent: { acceptTerms: boolean; marketingOptIn: boolean }) =>
    request<unknown>("POST", "/api/auth/sign-up/email", { name, email, password, ...consent }),
  signOut: () => request<unknown>("POST", "/api/auth/sign-out", {}),

  /** The API answers the same for unknown emails, so this never reveals whether an account exists. */
  sendCode: (email: string, type: OtpType) => request<unknown>("POST", "/api/auth/email-otp/send-verification-otp", { email, type }),
  verifyEmail: (email: string, otp: string) => request<unknown>("POST", "/api/auth/email-otp/verify-email", { email, otp }),
  signInWithCode: (email: string, otp: string) => request<unknown>("POST", "/api/auth/sign-in/email-otp", { email, otp }),
  resetPassword: (email: string, otp: string, password: string) =>
    request<unknown>("POST", "/api/auth/email-otp/reset-password", { email, otp, password }),
};
